'use client';
import { createContext, useContext, useState, useCallback } from 'react';

const KeyboardStateContext = createContext(null);

export function KeyboardStateProvider({ children }) {
    const [keyboard, setKeyboard] = useState({ types: [] });
    const [resultModal, setResultModal] = useState(null); // { title, body, status } or null

    const updateKeyboard = useCallback((payload) => {
        // payload is { keyboard: {...} } like the old keyboardTest action
        if (payload?.keyboard) setKeyboard(payload.keyboard);
    }, []);

    const showModal = useCallback((data) => {
        setResultModal(data);
    }, []);

    const closeModal = useCallback(() => setResultModal(null), []);

    return (
        <KeyboardStateContext.Provider value={{ keyboard, updateKeyboard, resultModal, showModal, closeModal }}>
            {children}
        </KeyboardStateContext.Provider>
    );
}

export function useKeyboardState() {
    const ctx = useContext(KeyboardStateContext);
    if (!ctx) throw new Error('useKeyboardState must be used within KeyboardStateProvider');
    return ctx;
}
